// Flag della checklist OSS: reset automatico a ogni cambio turno (Mattina/Pomeriggio/Notte) e ogni giorno
const dayKey = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };
const turnoNow = () => { const h = new Date().getHours(); if (h >= 7 && h < 14) return "mattina"; if (h >= 14 && h < 20) return "pomeriggio"; return "notte"; };
const k = (name) => `oss_chk:${name}:${dayKey()}:${turnoNow()}`;

export const markChecklist = (name) => { try { localStorage.setItem(k(name), "1"); } catch (e) { /* noop */ } };
export const isChecked = (name) => { try { return localStorage.getItem(k(name)) === "1"; } catch (e) { return false; } };
export { turnoNow };
